export default __webpack_public_path__ + "static/media/credit_card.511a5ee0.svg";